export default function _isPlaceholder(a) {
    return (a != null && typeof a === "object" && a["@@functional/placeholder"] === true);
}
//# sourceMappingURL=_isPlaceholder.js.map